import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Review from 'components/Review'
import Typography from 'components/Typography'

import classes from './ListingInfo.module.scss'

/** @type {import("./types").default} */
const ListingInfo = ({
  ctaUrl = '',
  isPremium = false,
  name,
  productId,
  onCtaClick = () => {},
  onReviewsNumberClick = () => {},
  rating,
  reviewsNum,
  reviewsUrl,
  tagline,
  listingPosition = 0,
}) => {
  return (
    <div className="ListingInfo">
      <ClickoutWrapper
        url={ctaUrl}
        isClickout={isPremium}
        buyerIntentProductId={productId}
        buyerIntentSourceLocation="compare/mobile-alternative:name"
        buyerIntentTrackAdClick={isPremium}
        onClick={onCtaClick}
        listingPosition={listingPosition}
      >
        <Link variant="heading-md" forceComponent="h3" className={classes.link}>
          {name}
          {isPremium && <Icon icon={['far', 'external-link']} size="12" />}
        </Link>
      </ClickoutWrapper>
      <div className={classes.ratings}>
        <Review.Rating
          className={clsx(classes.rating)}
          href={reviewsUrl}
          onReviewsNumberClick={onReviewsNumberClick}
          rating={rating}
          reviewsNum={reviewsNum}
          withRatingNum
          xs
        />
      </div>
      <Typography variant="tight-sm" className={classes.tagline}>
        {tagline}
      </Typography>
    </div>
  )
}

export default ListingInfo
